function useMutableState(initialize) {
    var _a;
    const mutableState = useRef((_a = initialize === null || initialize === void 0 ? void 0 : initialize()) !== null && _a !== void 0 ? _a : Object()).current;
    return mutableState;
}
export default useMutableState;
